import Button from "../../../Framework/Components/Buttons/Button";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faBroom, faFilterList} from "@fortawesome/pro-solid-svg-icons";
import FilterItem from "../../FilterItem";
import {formatLocaleDate} from "../../../Framework/Constants/DateHelpers";
import {ButtonSize} from "../../../Framework/Data/Enums/Generic";
import React from "react";
import {useLayout} from "../../../Framework/Providers/LayoutProvider";
import {useSendMailHistory} from "../../../Providers/SendMailHistoryProvider";
import {ColourMod} from "../../../Framework/Data/Enums/LayoutEnums";

type SendsHistoryFilterControlType = {

}

type SendHistoryFilterButtonType = {

}

const SendHistoryFilterButton = (props: SendHistoryFilterButtonType) => {
    const { UpdateFilterActive } = useSendMailHistory();

    return (
        <Button
            squared={true}
            title={'Filter'}
            colour={ColourMod.Primary}
            icon={ <FontAwesomeIcon icon={faFilterList} fixedWidth={true} /> }
            onClick={() => UpdateFilterActive(true)}
        />
    )
}

const SendsHistoryFilterControl = (props: SendsHistoryFilterControlType) => {
    const { isMedium } = useLayout();
    const { pageId, userId, HandleFilterRemoved, HandleFilterCleared, filterSettings } = useSendMailHistory();

    if(!filterSettings || Object.keys(filterSettings).length === 0) return null;

    return (
        <div className={'flex-row flex-wrap align-center flex-gap-xs'}>
            {!pageId && filterSettings.pageIds && (
                <FilterItem
                    content={`${filterSettings.pageIds.length} ${filterSettings.pageIds.length === 1 ? 'Page' : 'Pages'}`}
                    callback={() => HandleFilterRemoved('pageIds')}
                />
            )}

            {!userId && filterSettings.userIds && (
                <FilterItem
                    content={`${filterSettings.userIds.length} ${filterSettings.userIds.length === 1 ? 'User' : 'Users'}`}
                    callback={() => HandleFilterRemoved('userIds')}
                />
            )}

            {filterSettings.startDate && (
                <FilterItem
                    content={`Start Date: ${formatLocaleDate(filterSettings.startDate)}`}
                    callback={() => HandleFilterRemoved('startDate')}
                />
            )}

            {filterSettings.endDate && (
                <FilterItem
                    content={`End Date: ${formatLocaleDate(filterSettings.endDate)}`}
                    callback={() => HandleFilterRemoved('endDate')}
                />
            )}

            {Object.entries(filterSettings).length > 0 && !(Object.entries(filterSettings).length === 1 && (pageId && filterSettings.pageIds || userId && filterSettings.userIds)) && (
                <Button title={'Clear Filters'} icon={<FontAwesomeIcon icon={faBroom} fixedWidth={true} />} iconOnly={!isMedium} size={ButtonSize.Small} onClick={() => HandleFilterCleared()}/>
            )}
        </div>
    )
}

export default SendsHistoryFilterControl

export { SendHistoryFilterButton }